import { Palette, alpha } from '@mui/material/styles';

import { MuiThemeComponentsType } from '../types';
import { ThemeType } from '../../constants';

export default (palette: Palette): MuiThemeComponentsType['MuiButton'] => ({
  styleOverrides: {
    root: {
      borderRadius: 8,
    },
  },
  variants: [
    {
      props: { variant: 'outlined', color: 'tertiary' },
      style: () => ({
        backgroundColor: palette.mode === ThemeType.LIGHT ? 'white' : '#262626',
        color: palette.text.primary,
        borderColor: palette.mode === ThemeType.LIGHT ? '#D4D4D4' : '#404040',
        fontWeight: 500,
        '&:hover': {
          backgroundColor: palette.mode === ThemeType.LIGHT ? '#FAFAFA' : '#171717',
          borderColor: palette.mode === ThemeType.LIGHT ? '#A3A3A3' : '#525252',
        },
        '&:focus': {
          borderColor: palette.mode === ThemeType.LIGHT ? '#737373' : '#737373',
          outline: `2px solid ${palette.primary.main}40`,
          outlineOffset: '2px',
        },
      }),
    },
    {
      props: { size: 'xlarge' },
      style: {
        padding: '11px 24px', // Larger padding
      },
    },
    {
      props: { color: 'inherit', variant: 'contained' },
      style: {
        backgroundColor: palette.grey[100],
        '&:hover': {
          backgroundColor: palette.grey[400],
        },
        color: 'rgba(0, 0, 0, 0.87)',
      },
    },
    {
      props: { color: 'inherit', variant: 'outlined' },
      style: {
        color: palette.text.primary,
        borderColor: palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
        '&.Mui-disabled': {
          border: `1px solid ${palette.action.disabledBackground}`,
        },
        '&:hover': {
          borderColor: palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
          backgroundColor: alpha(palette.text.primary, palette.action.hoverOpacity),
        },
      },
    },
  ],
  defaultProps: {
    color: 'inherit',
  },
});
